export const getDate = (dateTime) => {
  const date = dateTime.split(" ")[0];
  const [year, month, day] = date.split("-");
  return `${day}/${month}/${year}`;
};

export const getTime = (dateTime) => {
  const time = dateTime.split(" ")[1];
  return time;
};

export const configurePoint = (pointType, setReadingType, setUnit) => {
  switch (String(pointType)) {
    case "1":
      setReadingType(["Nível"]);
      setUnit(["m.c.a."]);
      break;

    case "2":
      setReadingType(["Bomba"]);
      setUnit("");
      break;

    case "10":
    case "12":
      setReadingType(["Vazão", "Volume"]);
      setUnit(["m³/h", "m³"]);
      break;

    default:
      break;
  }
};
